import cestMetadata from './data/metadata.json';
import type { CestDataVersion } from './types.js';

export const CEST_DATA_VERSION: CestDataVersion = cestMetadata as CestDataVersion;
